export enum AnalyticsEvents {
  ENVIAR_MENSAGEM_NORMAL = 'ENVIAR_MENSAGEM_NORMAL',
  ENVIAR_AUDIO = 'ENVIAR_AUDIO',
  GRAVAR_AUDIO = 'GRAVAR_AUDIO',
  CANCELAR_AUDIO = 'CANCELAR_AUDIO',
  DOWNLOAD_FILE = 'DOWNLOAD_FILE',
  ENVIAR_MENSAGEM_MODELO = 'ENVIAR_MENSAGEM_MODELO',
  ARQUIVAR_CONVERSA_TELA_GESTAO = 'ARQUIVAR_CONVERSA_TELA_GESTAO',
  ARQUIVAR_CONVERSA_TELA_MSGS = 'ARQUIVAR_CONVERSA_TELA_MSGS',
  FILTRO_NAO_CADASTRADO = 'FILTRO_NAO_CADASTRADO',
  FILTRO_NAO_LIDAS = 'FILTRO_NAO_LIDAS',
  FILTRO_MINHAS_CONVERSAS = 'FILTRO_MINHAS_CONVERSAS',
  FILTRO_CONVERSAS_ARQUIVADAS = 'FILTRO_CONVERSAS_ARQUIVADAS',
  FILTRO_AGUARDANDO_PRIMEIRO_AT = 'FILTRO_AGUARDANDO_PRIMEIRO_AT',
  FILTRO_CONVERSA_AUTOMATIZADA = 'FILTRO_CONVERSA_AUTOMATIZADA',
  FILTRO_CLIENTES_SEM_RESPOSTA = 'FILTRO_CLIENTES_SEM_RESPOSTA',
  FILTRO_NAVEGANDO = 'FILTRO_NAVEGANDO',
  SELECIONAR_RESPOSTA_PRONTA = 'SELECIONAR_RESPOSTA_PRONTA',
  EFETUAR_TRANSFERENCIA = 'EFETUAR_TRANSFERENCIA',
  PUXAR_CONVERSA = 'PUXAR_CONVERSA',
  FECHAR_MICROFONE_BLOQUEADO = 'FECHAR_MICROFONE_BLOQUEADO',
  FECHAR_PERMITIR_MICROFONE = 'FECHAR_PERMITIR_MICROFONE',
  FORA_TOP_2_MODELO_MSG = 'FORA_TOP_2_MODELO_MSG',
  TOP_2_MODELO_MSG = 'TOP_2_MODELO_MSG',
  ENVIAR_MIDIA = 'ENVIAR_MIDIA',
  ABRIR_PERFIL_CLIENTE = 'ABRIR_PERFIL_CLIENTE',
  FECHAR_PERFIL_CLIENTE = 'FECHAR_PERFIL_CLIENTE',
  BUSCAR_POR_DESTINO = 'BUSCAR_POR_DESTINO',
  VISUALIZAR_AREA_FORMULARIOS = 'VISUALIZAR_AREA_FORMULARIOS',
  ENVIAR_FORMULARIO = 'ENVIAR_FORMULARIO',
  CLICAR_RESPOSTA_PRONTA_ATALHO = 'CLICAR_RESPOSTA_PRONTA_ATALHO',
  ABRIR_JANELA_PIP = 'ABRIR_JANELA_PIP',
  FECHAR_JANELA_PIP = 'FECHAR_JANELA_PIP',
  BLOQUEAR_CONTATO = 'BLOQUEAR_CONTATO',
  DESBLOQUEAR_CONTATO = 'DESBLOQUEAR_CONTATO',
  CRIAR_ETIQUETA = 'CRIAR_ETIQUETA',
  ATRIBUIR_ETIQUETA = 'ATRIBUIR_ETIQUETA',
  REMOVER_ETIQUETA = 'REMOVER_ETIQUETA',
  GERAR_RESUMO_CLIENTE = 'GERAR_RESUMO_CLIENTE',
  BUSCAR_NA_CONVERSA = 'BUSCAR_NA_CONVERSA',
  PESQUISAR_CLIENTE_NOVA_CONVERSA = 'PESQUISAR_CLIENTE_NOVA_CONVERSA',
  ENVIAR_COBRANCA = 'ENVIAR_COBRANCA',
  VISUALIZAR_AREA_COBRANCA = 'VISUALIZAR_AREA_COBRANCA',
  ENCADEAR_RESPOSTA = 'ENCADEAR_RESPOSTA',
  BUSCA_GLOBAL_CONVERSA = 'BUSCA_GLOBAL_CONVERSA',
  BUSCA_GLOBAL_MENSAGEM = 'BUSCA_GLOBAL_MENSAGEM'
}
